"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.heading = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var HfilterSortDropdown_1 = require("@/pages/search/components/HfilterSortDropdown");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.heading), { showStar: !state.sfav.sectionFollowingPlace.opened && !state.sfav.sectionSavedSearch.opened, headingImage: state.results.textImages && state.results.textImages.title ? state.results.textImages.title : null })); };
var mapDispatchToProps = function (dispatch) { return ({}); };
exports.heading = function (props) {
    var image = (React.createElement("img", { src: props.headingImage }));
    var text = (React.createElement("h1", { className: "c-result__head-title" }, props.heading));
    return (React.createElement("div", { className: "c-result__head" },
        props.headingImage ? image : text,
        React.createElement("div", { className: "c-result__head-action" },
            React.createElement(HfilterSortDropdown_1.default, null))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.heading);
